export default function(fields) {
  return {
    ...fields,
    fileUrls: fields.fileUrls && fields.fileUrls.map(item => item.url),
    helpers: undefined
  }
}
